import { render, staticRenderFns } from "./DistributorAppr.vue?vue&type=template&id=04a70b6f&"
import script from "./DistributorAppr.vue?vue&type=script&lang=js&"
export * from "./DistributorAppr.vue?vue&type=script&lang=js&"
import style0 from "./DistributorAppr.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports